import { FaClock, FaLightbulb } from "react-icons/fa";
import { Link } from "react-router-dom";
import "../../styles/art/NewsSection.css";

const newsData = {
  highlight: {
    slug: "trien-lam-my-thuat-thieu-nhi-2025",
    title: "Triển lãm Mỹ thuật Thiếu nhi 2025",
    date: "04/08/2025",
    description:
      "Triển lãm thường niên của Design24 quy tụ hàng trăm tác phẩm đặc sắc của học viên trên toàn quốc, là sân chơi lớn để các em thể hiện tư duy sáng tạo.",
    image: "/images/art/news/highlight.webp",
    icon: <FaLightbulb />,
  },
  latestNews: [
    {
      id: 1,
      slug: "khai-giang-khoa-hoc-moi",
      title: "Khai giảng khóa học mới",
      date: "01/08/2025",
      image: "/images/art/news/news1.webp",
    },
    {
      id: 2,
      slug: "workshop-ve-mau-nuoc-cho-thieu-nhi",
      title: "Workshop vẽ màu nước cho thiếu nhi",
      date: "25/07/2025",
      image: "/images/art/news/news2.webp",
    },
    {
      id: 3,
      slug: "hoc-ve-manga-tu-can-ban-den-nang-cao",
      title: "Học vẽ Manga từ căn bản đến nâng cao",
      date: "20/07/2025",
      image: "/images/art/news/news3.webp",
    },
  ],
  artTips: [
    {
      id: 1,
      slug: "5-ky-thuat-to-mau-chi-nang-cao",
      title: "5 kỹ thuật tô màu chì nâng cao",
      date: "28/07/2025",
      image: "/images/art/news/tip1.webp",
    },
    {
      id: 2,
      slug: "tu-duy-bo-cuc-trong-tranh-thieu-nhi",
      title: "Tư duy bố cục trong tranh thiếu nhi",
      date: "18/07/2025",
      image: "/images/art/news/tip2.webp",
    },
    {
      id: 3,
      slug: "cach-truyen-cam-xuc-qua-net-ve",
      title: "Cách truyền cảm xúc qua nét vẽ",
      date: "10/07/2025",
      image: "/images/art/news/tip3.webp",
    },
  ],
};

function NewsSection() {
  return (
    <section className="news-section">
      <div className="news-section__container">
        <h2 className="news-section__title">TIN TỨC</h2>
        <div className="news-section__content">
          {/* Highlight News */}
          <Link
            to={`/art/news/${newsData.highlight.slug}`}
            className="news-highlight"
            aria-label={`Xem chi tiết: ${newsData.highlight.title}`}
          >
            <img
              src={newsData.highlight.image}
              alt={newsData.highlight.title}
              className="news-highlight__image"
            />
            <div className="news-highlight__info">
              <div className="news-highlight__icon">
                {newsData.highlight.icon}
              </div>
              <h3 className="news-highlight__title">
                {newsData.highlight.title}
              </h3>
              <p className="news-highlight__date">
                <FaClock /> {newsData.highlight.date}
              </p>
              <p className="news-highlight__description">
                {newsData.highlight.description}
              </p>
            </div>
          </Link>

          {/* Latest News */}
          <div className="news-list">
            <h3 className="news-list__heading">TIN TỨC MỚI NHẤT</h3>
            {newsData.latestNews.map((item) => (
              <Link
                key={item.id}
                to={`/art/news/${item.slug}`}
                className="news-card"
                aria-label={`Xem chi tiết: ${item.title}`}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="news-card__image"
                />
                <div className="news-card__content">
                  <h4 className="news-card__title">{item.title}</h4>
                  <p className="news-card__date">
                    <FaClock /> {item.date}
                  </p>
                </div>
              </Link>
            ))}
          </div>

          {/* Art Knowledge */}
          <div className="news-list">
            <h3 className="news-list__heading">KIẾN THỨC HỘI HỌA</h3>
            {newsData.artTips.map((item) => (
              <Link
                key={item.id}
                to={`/art/news/${item.slug}`}
                className="news-card"
                aria-label={`Xem chi tiết: ${item.title}`}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="news-card__image"
                />
                <div className="news-card__content">
                  <h4 className="news-card__title">{item.title}</h4>
                  <p className="news-card__date">
                    <FaClock /> {item.date}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewsSection;
